import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { eventConfig } from "@/config/eventConfig";
import RegistrationForm from "@/components/sections/RegistrationForm";

/**
 * Pop-up registration form. Reuses the same RegistrationForm component
 * used in the on-page Registration section.
 *
 * Props:
 *  - open (bool)
 *  - onOpenChange (fn)
 */
export const RegistrationModal = ({ open, onOpenChange }) => {
  const { registration, event } = eventConfig;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="registration-modal"
        className="max-w-lg w-[calc(100%-2rem)] p-0 gap-0 border-0 bg-transparent shadow-none max-h-[92vh] overflow-y-auto"
      >
        {/* Accessible heading */}
        <div className="px-1 pb-4 text-center">
          <DialogTitle className="text-xl font-bold text-white">
            {registration.heading}
          </DialogTitle>
          <DialogDescription className="mt-1 text-sm" style={{ color: "rgba(255,255,255,0.8)" }}>
            {event.dateLabel} · {event.timeLabel}
          </DialogDescription>
        </div>
        <RegistrationForm inModal onSuccess={() => { /* keep modal open to show confirmation */ }} />
      </DialogContent>
    </Dialog>
  );
};

export default RegistrationModal;
